var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVehicleRegistrationFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 152,
  height: 129,
  viewBox: "0 0 152 129",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-public/img/icons/documents/vehicle_registration_filled.svg__filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.9751 69C42.675 69 40 66.3137 40 63V26C40 22.6863 42.675 20 45.9751 20H75V69H45.9751ZM77 69H106.025C109.325 69 112 66.3137 112 63V26C112 22.6863 109.325 20 106.025 20H77V69Z",
  fill: "#005FF9"
}), /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 29,
  width: 19,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 34,
  width: 15,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 48,
  y: 39,
  width: 12,
  height: 2,
  rx: 1,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M88.5335 41.548C88.7915 40.6036 89.6234 39.9927 90.4352 40.0064C90.7912 39.9995 92.3544 39.9995 93.9981 40.0004C95.6418 39.9995 97.205 39.9995 97.561 40.0064C98.3728 39.9927 99.2047 40.6036 99.4628 41.548L100.097 43.8725C100.556 43.8982 100.922 44.272 100.922 44.73C100.922 45.0299 100.764 45.2946 100.526 45.4484C100.816 45.7036 100.996 46.0568 100.996 46.4512V47.7402C100.996 47.9413 100.949 48.1312 100.866 48.3005C100.769 48.4913 100.773 48.7164 100.876 48.9037C100.955 49.0343 100.996 49.1882 100.996 49.3514C100.996 49.8481 100.613 50.258 100.121 50.3121V50.7478C100.121 51.4585 99.5336 52.0368 98.8093 52.0368C98.085 52.0368 97.4972 51.4585 97.4972 50.7478V50.3572H90.4991V50.7478C90.4991 51.4585 89.9112 52.0368 89.1869 52.0368C88.4626 52.0368 87.8748 51.4585 87.8748 50.7478V50.3121C87.3831 50.258 87 49.8481 87 49.3514C87 49.1882 87.0411 49.0352 87.1137 48.9003C87.2152 48.7147 87.2187 48.493 87.1225 48.3039C87.0472 48.1312 87 47.9404 87 47.7402V46.4512C87 46.0637 87.1741 45.7165 87.4488 45.4802C87.1811 45.3333 87 45.0523 87 44.73C87 44.2557 87.3919 43.8716 87.8739 43.8716L88.5335 41.548ZM89.6563 46.8581C90.1199 46.8581 90.4961 47.2343 90.4961 47.6979C90.4961 48.1615 90.1199 48.5377 89.6563 48.5377C89.1928 48.5377 88.8166 48.1615 88.8166 47.6979C88.8166 47.2343 89.1928 46.8581 89.6563 46.8581ZM98.3368 46.8581C98.8004 46.8581 99.1766 47.2343 99.1766 47.6979C99.1766 48.1615 98.8004 48.5377 98.3368 48.5377C97.8733 48.5377 97.4971 48.1615 97.4971 47.6979C97.4971 47.2343 97.8733 46.8581 98.3368 46.8581ZM97.4972 45.0386H97.9426C98.108 45.0386 98.2647 44.9639 98.3653 44.8379C98.4668 44.7119 98.5001 44.5473 98.4572 44.3937C98.2647 43.7017 97.9637 42.6259 97.8053 42.0582C97.7431 41.8349 97.5313 41.6795 97.2898 41.6795H93.9967H90.7036C90.4621 41.6795 90.2503 41.8349 90.1882 42.0582C90.0298 42.6259 89.7287 43.7017 89.5362 44.3937C89.4933 44.5473 89.5266 44.7119 89.6281 44.8379C89.7287 44.9639 89.8854 45.0386 90.0508 45.0386H90.4962C91.0055 45.0369 96.9879 45.0369 97.4972 45.0386Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "svg-public/img/icons/documents/vehicle_registration_filled.svg__filter0_d",
  x: 0,
  y: 0,
  width: 152,
  height: 129,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgVehicleRegistrationFilled as ReactComponent };